import { motion } from "framer-motion";
import { CreditCard, Headphones, Settings, Rocket, Users } from "lucide-react";

const steps = [
  {
    icon: CreditCard,
    step: "01",
    title: "Escolha seu Plano",
    description: "Light para agilidade ou Elite para segurança total. Assine e comece.",
    color: "cyber-cyan",
  },
  {
    icon: Headphones,
    step: "02",
    title: "Acesse a Plataforma",
    description: "Receba suas credenciais e faça login no painel Zavvi.",
    color: "electric-purple",
  },
  {
    icon: Settings,
    step: "03",
    title: "Configure sua Equipe",
    description: "Adicione seus atendentes e defina as regras de atendimento.",
    color: "cyber-cyan",
  },
  {
    icon: Users,
    step: "04",
    title: "Convide sua Equipe",
    description: "Atendentes ilimitados. Todos no mesmo painel unificado.",
    color: "electric-purple",
  },
  {
    icon: Rocket,
    step: "05",
    title: "Comece a Atender!",
    description: "Pronto para receber leads e atender seus clientes com excelência.",
    color: "cyber-cyan",
  },
];

const HowItWorksSection = () => {
  return (
    <section id="como-funciona" className="py-16 md:py-24 relative overflow-hidden" aria-labelledby="how-it-works-heading">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-electric-purple/5 to-transparent" aria-hidden="true" />
      
      <div className="container mx-auto px-4 relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-3xl mx-auto mb-12 md:mb-16"
        >
          <h2 id="how-it-works-heading" className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-display font-bold mb-4 md:mb-6">
            Sua Jornada{" "}
            <span className="text-gradient-zavvi">em 5 passos</span>
          </h2>
          <p className="text-base md:text-lg text-body-text">
            Da assinatura ao primeiro atendimento com suporte especializado.
          </p>
        </motion.div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-4 max-w-7xl mx-auto">
          {steps.map((step, index) => (
            <motion.div
              key={step.step}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="relative"
            >
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-[60%] w-[80%] h-[2px] bg-gradient-to-r from-border to-transparent" />
              )}
              
              <div className="glass-card p-5 md:p-6 rounded-2xl h-full hover:border-cyber-cyan/30 transition-all duration-300 group">
                {/* Step Number */}
                <div className={`text-${step.color} text-sm font-bold mb-4 opacity-60`}>
                  PASSO {step.step}
                </div>
                
                {/* Icon */}
                <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl bg-${step.color}/10 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <step.icon className={`w-6 h-6 md:w-7 md:h-7 text-${step.color}`} />
                </div>
                
                {/* Content */}
                <h3 className="text-base md:text-lg font-display font-bold mb-2 text-foreground">
                  {step.title}
                </h3>
                <p className="text-xs md:text-sm text-body-text">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
